import React, { useState } from 'react';
import styled from 'styled-components';

import { colors } from '../../../core';

const Header = styled.div`
  display: block;
  font-family: ${({ theme }) => theme.fontFamily || `Quicksand, sans-serif`};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  -webkit-appearance: none;
  background-color: transparent;
  border: 0;
  color: ${colors.primary};
  cursor: pointer;
  padding: 0;
`;

const CollapseContainer = styled.div`
  display: block;
  position: relative;
  background-color: ${colors.riverstone};
  width: 100%;
  padding: 5px;
`;

const CollapseSection = styled.div`
  display: block;
  padding: 10px 0;
`;

interface CollapseProps {
  title: string;
  defaultOpen: boolean;
  children: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> = ({ defaultOpen, title, children }) => {
  const [isOpened, setOpened] = useState(defaultOpen);
  const handleClick = () => setOpened(!isOpened);
  return (
    <CollapseContainer>
      <React.Fragment>
        <Header onClick={handleClick}>{title}</Header>
        {isOpened && <CollapseSection>{children}</CollapseSection>}
      </React.Fragment>
    </CollapseContainer>
  );
};
export default Collapse;
